import { IFilterService, IHttpService, IPromise, IRootScopeService } from "angular";
import dayjs from "@gtmhub/dayjs";
import { EnvironmentService } from "@gtmhub/env";
import { HomeScreenView } from "@gtmhub/home/utils";
import { CurrentUserService } from "@gtmhub/users";
import { ICollection } from "@webapp/core/core.models";
import { NavigationEvents } from "@webapp/navigation/components/navigation/navigation.events";

export interface IAssigneeStats {
  assigneeId: string;
  progress: number;
  attainmentDelta: ISessionDelta;
}

export interface ISessionProgress {
  assigneesStats: IAssigneeStats[];
  sessionId: string;
  sessionProgress: number;
  sessionAttainmentDelta: ISessionDelta;
}

export interface ISessionDelta {
  current: number;
  delta: number;
  deltaPercentage: number;
  previous: number;
}

export class HomeService {
  public static $inject = ["$http", "EnvironmentService", "$filter", "CurrentUserService"];

  constructor(private $http: IHttpService, private env: EnvironmentService, private $filter: IFilterService, private currentUserService: CurrentUserService) {}

  private strings = {
    deadlines: { overdue: "overdue" },
  };

  public getSessionsProgress(activeSessionIds: string, employeeIdAndTeamIds: string): IPromise<ICollection<ISessionProgress>> {
    const url = this.env.getApiEndpoint(`/sessions/${activeSessionIds}/assignees/${employeeIdAndTeamIds}/stats`);

    return this.$http.get<ICollection<ISessionProgress>>(url).then((response) => response.data);
  }

  public calcDeadline = (date: string): string => (date ? dayjs(date).fromNow() : this.strings.deadlines.overdue);

  public removeDisabledAndFilledInCheckIns(checkinSettings, filledInCheckins) {
    const templateIds = filledInCheckins.map((item) => item.templateId);
    return checkinSettings.filter((item) => !(!item.reflectionsEnabled || templateIds.includes(item.templateId)));
  }

  public roundProgressValue = (value: number): number => {
    return +this.$filter("number")(value * 100, 0) / 100;
  };

  public notifyTabChanged(scope: IRootScopeService, tab: HomeScreenView): void {
    this.currentUserService.setUserSetting({ homeScreen: tab });

    if (tab === HomeScreenView.feed) {
      scope.$broadcast(NavigationEvents.SUB_NAV_SWITCH_TO_FEED);
    } else {
      scope.$broadcast(NavigationEvents.SUB_NAV_SWITCH_TO_DASHBOARD);
    }
  }
}
